import React from 'react';

const Jira = (props) => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 32"
    strokeWidth={2}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="5" y="7" width="22" height="18" rx="2" strokeLinejoin="round" />
    <path d="M11 16l3 3 7-7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Jira;
